





import { Vue, Component } from 'vue-property-decorator'
import ajax from '@/lib/ajax'
import cookie from 'js-cookie'
import url from '@/lib/url'
import util from '@/lib/util'
import appconst from '@/lib/appconst'
import moment from 'moment'
import app from '@/lib/app'
import AuthenticateModel from '@/store/models/authenticate-model'

const homePath = '/'

@Component
export default class Authenticate extends Vue {
	model: AuthenticateModel = new AuthenticateModel()
	async beforeCreate() {
		let localOpenid = app.getOpenId()
		if (localOpenid !== null) {
			this.model = new AuthenticateModel()
			this.model.openId = localOpenid!
			this.model.isWX = true
			// 通过openId去登录
			let userInfo = await app.auth.authenticateByOpenId(this.model)
			if (userInfo.result === '没有绑定OpenId')
				localStorage.removeItem('openid')
			localOpenid = null
		}

		let returnUrl = app.getReturnUrl()
		if (localOpenid) {
			if (returnUrl)
				this.$router.replace(returnUrl)
			else
				this.$router.replace(homePath)
			return
		}
		let openid = this.$route.query.openid
		if (!openid) {
			if (returnUrl)
				app.setReturnUrl(returnUrl)
			window.location.href = url + 'WeixinOAuth/Index'
		} else {
			app.setOpenId(openid.toString())
			this.model = new AuthenticateModel()
			this.model.openId = openid.toString()
			this.model.isWX = true
			// 通过openId去登录
			let userInfo = await app.auth.authenticateByOpenId(this.model)
			console.log(userInfo)
			if (userInfo.result === '没有绑定OpenId') {
				this.$router.push('/login')
			} else {
				cookie.set('access_token', userInfo.result)

				if (returnUrl)
					this.$router.replace(returnUrl)
				else
					this.$router.replace(homePath)
			}
		}
	}
}
